// test1485
(1485 && 0);
